<h1 class="twc-h1">{{ 'CREATE_PROJECT.ADD_PROJECT_SELECT_OPTION' | translate }}</h1>

<p class="twc-body">{{ 'CREATE_PROJECT.ADD_PROJECT_DESCRIPTION' | translate }}</p>

<twc-radio *ngFor="let option of dataOptions; index as idx">
    <input twcRadioInput name="data-type" (change)="setSelectedType($event)" [value]="idx">
    <label twcRadioLabel>{{ option.keyText | translate }}</label>
</twc-radio>